var _g, _path, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 345,
    height: 246,
    viewBox: "0 0 345 246",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5544_28084)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118 231.788C118 235.101 120.686 237.788 124 237.788H236C239.314 237.788 242 235.101 242 231.788V89.1523C242 85.8386 239.314 83.1523 236 83.1523H124C120.686 83.1523 118 85.8386 118 89.1523V231.788Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118 94.8234H242V76.0234C242 72.7097 239.314 70.0234 236 70.0234H124C120.686 70.0234 118 72.7097 118 76.0234V94.8234Z",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.683 74.3999H198.236V61.2705H164.683V74.3999Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.13 113.788H230.33V105.035H131.13V113.788Z",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.8 137.129H220.117V132.753H142.8V137.129Z",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.341 224.659H218.658V220.282H141.341V224.659Z",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.8 125.459H220.117V121.082H142.8V125.459Z",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.259 20L175.127 61.2706H196.776L175.521 20H154.259Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.936 20L164.683 61.2706H186.333L204.2 20H182.936Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.5 27.5L191 50.5L198 34L179.5 27.5Z",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170 146.875H149.875V167H170V146.875ZM167.125 164.125H152.75V149.75H167.125V164.125Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.562 204.375H188.688V210.125H213.125V207.25H191.562V204.375Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.25 152.625H155.625V161.25H164.25V152.625Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.875 210.125H170V190H149.875V210.125ZM152.75 192.875H167.125V207.25H152.75V192.875Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.25 195.75H155.625V204.375H164.25V195.75Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193 146.875V167H213.125V146.875H193ZM210.25 164.125H195.875V149.75H210.25V164.125Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.375 152.625H198.75V161.25H207.375V152.625Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.125 169.875H207.375V175.625H213.125V169.875Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.625 181.375H149.875V187.125H155.625V181.375Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.062 169.875H168.562V172.75H182.938V167V164.125H185.812V158.375H182.938H180.062H177.188V152.625H180.062V155.5H190.125V146.875H187.25V152.625H182.938V146.875H181.5H175.75H174.312V161.25H180.062V164.125H174.312V167H180.062V169.875Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.188 178.5H159.938H162.812H164.25V181.375H158.5V184.25H164.25V187.125H175.75V184.25H167.125V181.375V175.625H162.812V171.312H159.938V175.625H157.062V169.875H149.875V172.75H154.188V178.5Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.5 204.375V197.188H175.75V191.438H172.875V200.062H178.625V204.375H172.875V207.25H178.625V210.125H185.812V207.25H181.5V204.375Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.875 175.625H190.125V168.438H187.25V178.5H201.625V175.625H198.75V172.75H203.062V169.875H198.75H195.875H193V172.75H195.875V175.625Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193 201.5H197.312V204.375H203.062V201.5V198.625V194.313H197.312V198.625H193V194.313H190.125V198.625H187.25V187.125H184.375V184.25H181.5V175.625H171.438V181.375H174.312V178.5H178.625V184.25V190H184.375V198.625V201.5H187.25H190.125H193Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.25 182.812H205.938H203.062H195.875V188.562H193V182.812H190.125V191.438H198.75V185.688H203.062V190H205.938V185.688H210.25V194.312H205.938V202.938H213.125V200.062H208.812V197.188H213.125V185.688V182.812V178.5H210.25V182.812Z",
    fill: "#333333"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M163.052 14.8235L75.6885 83.2754L9.22099 134.486L183.189 130.345L343.633 127.388L276.719 76.7671L198.285 15.0255L163.052 14.8235Z",
    fill: "url(#paint0_linear_5544_28084)",
    stroke: "url(#paint1_linear_5544_28084)",
    strokeWidth: 0.75
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_5544_28084)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 10,
    width: 224,
    height: 11,
    rx: 5.5,
    fill: "#444444"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5544_28084",
    x: 114,
    y: 20,
    width: 132,
    height: 225.788,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.28 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5544_28084"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5544_28084",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_5544_28084",
    x: 64,
    y: 8,
    width: 232,
    height: 19,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5544_28084"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5544_28084",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5544_28084",
    x1: 328.26,
    y1: 119.849,
    x2: 319.279,
    y2: 3.4432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FFFAFA",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FDEBEB",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBD3D3",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F8B1B1",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F48686",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#EF5252",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA1B1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5544_28084",
    x1: 329.566,
    y1: 120.266,
    x2: 320.505,
    y2: 2.83055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FFFAFA",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#FDEBEB",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#FBD3D3",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#F8B1B1",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F48686",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#EF5252",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA1B1B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScan);
export default __webpack_public_path__ + "static/media/scan.e324841a.svg";
export { ForwardRef as ReactComponent };